/* eslint-disable lines-around-comment */
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { getMultipleVideoSupportFeatureFlag, isDisplayNameVisible, isNameReadOnly
// @ts-ignore
 } from '../../../base/config/functions.any';
// @ts-ignore
import DisplayName from '../../../display-name/components/web/DisplayName';
import { THUMBNAIL_TYPE } from '../../constants';
// @ts-ignore
import StatusIndicators from './StatusIndicators';
const useStyles = makeStyles(() => {
    return {
        nameContainer: {
            display: 'flex',
            overflow: 'hidden',
            padding: '2px 0',
            '&>div': {
                display: 'flex',
                overflow: 'hidden'
            },
            '&:first-child': {
                marginLeft: '6px'
            }
        }
    };
});
const ThumbnailBottomIndicators = ({ className, isVirtualScreenshareParticipant, local, participantId, showStatusIndicators = true, thumbnailType }) => {
    const styles = useStyles();
    const _allowEditing = !useSelector(isNameReadOnly);
    const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
    const _isMultiStreamEnabled = useSelector(getMultipleVideoSupportFeatureFlag);
    const _showDisplayName = useSelector(isDisplayNameVisible);
    return (React.createElement("div", { className: className },
        showStatusIndicators && React.createElement(StatusIndicators, { audio: !isVirtualScreenshareParticipant, moderator: true, participantID: participantId, screenshare: _isMultiStreamEnabled
                ? isVirtualScreenshareParticipant
                : thumbnailType === THUMBNAIL_TYPE.TILE, thumbnailType: thumbnailType }),
        _showDisplayName && (React.createElement("span", { className: styles.nameContainer },
            React.createElement(DisplayName, { allowEditing: local ? _allowEditing : false, displayNameSuffix: local ? _defaultLocalDisplayName : '', elementID: local ? 'localDisplayName' : `participant_${participantId}_name`, participantID: participantId, thumbnailType: thumbnailType })))));
};
export default ThumbnailBottomIndicators;
